var map = {
	"./Employee/resources/components/canvas/blocks/modules/employees/admin/BlockPanel.vue": 3245,
	"./Project/resources/components/canvas/blocks/modules/project/admin/BlockPanel.vue": 74382,
	"./Project/resources/components/canvas/blocks/modules/project/block.js": 36015,
	"./Project/resources/components/canvas/blocks/modules/projectSuggestions/admin/BlockPanel.vue": 36027,
	"./WebsiteBlog/resources/components/canvas/blocks/modules/blog/admin/BlockPanel.vue": 56405,
	"./WebsiteBlog/resources/components/canvas/blocks/modules/blog/block.js": 65996,
	"./WebsiteBlog/resources/components/website/modules/blog/show.js": 80806
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31335;